
import { Link } from 'react-router-dom';

export default function ComparisonFooter() {
  return (
    <footer className="bg-black border-t border-dark-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10 sm:py-16">
        <div className="text-center mb-8 sm:mb-12">
          <img
            src="https://static.readdy.ai/image/607c853629dc4b228801d270367dd43a/15c46b4804cbc70ab5f2207b2f29e22b.png"
            alt="NeuroAgents Global AI"
            className="h-10 sm:h-12 w-auto mx-auto mb-3 sm:mb-4"
          />
          <p className="text-gray-400 text-xs sm:text-sm whitespace-nowrap">Global AI Automation</p>
        </div>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-8 sm:gap-12 mb-8 sm:mb-12">
          <div className="text-center sm:text-left">
            <h4 className="text-white font-bold mb-3 sm:mb-4 whitespace-nowrap text-sm sm:text-base">Links Institucionais</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/termos-de-uso" className="text-gray-400 hover:text-primary transition-colors text-xs sm:text-sm whitespace-nowrap cursor-pointer">
                  Termos de Uso
                </Link>
              </li>
              <li>
                <Link to="/politica-de-privacidade" className="text-gray-400 hover:text-primary transition-colors text-xs sm:text-sm whitespace-nowrap cursor-pointer">
                  Política de Privacidade
                </Link>
              </li>
              <li>
                <a 
                  href="https://wa.me/5541992584018" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-primary transition-colors text-xs sm:text-sm whitespace-nowrap cursor-pointer"
                >
                  Contato
                </a>
              </li>
            </ul>
          </div>

          <div className="text-center sm:text-left">
            <h4 className="text-white font-bold mb-3 sm:mb-4 whitespace-nowrap text-sm sm:text-base">Redes Sociais</h4>
            <div className="flex gap-4 justify-center sm:justify-start">
              <a
                href="https://www.instagram.com/neuroagentsglobal"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center bg-dark-secondary hover:bg-primary rounded-lg transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-lg sm:text-xl"></i>
              </a>
              <a
                href="https://wa.me/5541992584018"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center bg-dark-secondary hover:bg-primary rounded-lg transition-colors cursor-pointer"
              >
                <i className="ri-whatsapp-line text-lg sm:text-xl"></i>
              </a>
            </div>
          </div>

          <div className="text-center sm:text-left sm:col-span-2 md:col-span-1">
            <h4 className="text-white font-bold mb-3 sm:mb-4 whitespace-nowrap text-sm sm:text-base">Informações de Contato</h4>
            <p className="text-gray-400 text-xs sm:text-sm mb-2">
              <strong className="text-white">Email:</strong> contato@neuroagents.com.br
            </p>
            <p className="text-gray-400 text-xs sm:text-sm">
              <strong className="text-white">WhatsApp:</strong>{" "}
              <a 
                href="https://wa.me/5541992584018"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-primary transition-colors cursor-pointer"
              >
                (41) 99258-4018
              </a>
            </p>
          </div>
        </div>

        <div className="border-t border-dark-border pt-6 sm:pt-8 text-center">
          <p className="text-gray-500 text-xs sm:text-sm">
            © 2025 NeuroAgents Global AI. Todos os direitos reservados.
          </p>
          <p className="text-gray-600 text-[10px] sm:text-xs mt-2">
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-primary transition-colors cursor-pointer whitespace-nowrap"
            >
              Powered by Readdy
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
